export default __webpack_public_path__ + "static/hotblack-coffee-about1-094eb54bf0f36d66d5ca64ee663c2192.png";